import Anchor from "PageNavigation/Anchor";

export default class Page {
    name: string;
    title: string;
    component: JSX.Element;
    anchors: Anchor[]

    public constructor(name: string, title: string, component: JSX.Element, anchors: Anchor[] = []) {
        this.name = name;
        this.title = title;
        this.component = component;
        this.anchors = anchors;
    }
}